import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AppConfigContext = createContext({ config: null, refresh: () => {} });

export function AppConfigProvider({ children }) {
  const [config, setConfig] = useState(null);

  const refresh = useCallback(() => {
    api.getSmtp().then(setConfig).catch(() => setConfig({}));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <AppConfigContext.Provider value={{ config, refresh }}>
      {children}
    </AppConfigContext.Provider>
  );
}

export function useAppConfig() {
  return useContext(AppConfigContext);
}
